import CheckCircleDashedIcon from '@/assets/icons/check-circle-dashed.svg?react'
import CheckCircleIcon from '@/assets/icons/check-circle.svg?react'
import MoonIcon from '@/assets/icons/moon.svg?react'

export const availabilityTypeToIconMap = {
  available: CheckCircleIcon,
  optional: CheckCircleDashedIcon,
  unavailable: MoonIcon
}
